var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wxsub"},[_c('div',{staticClass:"tip"},[_vm._v("绑定成功")])])}]

export { render, staticRenderFns }